export const products = [
  { id: 1, price: 1000, quantity: 1 },
  { id: 2, price: 2000, quantity: 1 },
  { id: 3, price: 5000, quantity: 1 },
  { id: 4, price: 10000, quantity: 1 },
];
